const initialState = () => {
  return {
    isPropertySelected: false,
    propertyAddress: {
      streetNameOptions: [],
      propertyId: null,
      isStreetNameValid: null,
      properties: []
    },
    productDetails: {},
    orderDetails: {},
    taxAdjustmentDetails: {},
    taxAdjustmentOrderId: "",
    applicantInformation: {
      applicantInfo: {},
      mailingInfo: {},
      agentInfo: {}
    },
    applicationType: {},
    postOrderDetails: {},
    reasonConfigurations: {
      currentYearReasons: [],
      precedingYearReasons: []
    },
    errors: {
      applicationError: {
        hasError: null,
        error: []
      },
      createOrderError: {
        hasError: null,
        error: []
      },
      applicationError: {
        hasError: null,
        error: []
      },
      orderSummaryError: {
        hasError: null,
        error: []
      },
      taxAdjustmentError: {
        hasError: null,
        error: []
      },
      paymentError: {
        hasError: null,
        error: []
      },
      maintenanceError: {
        hasError: null,
        error: "",
      },
    }
  };
};

export default initialState;
